module.exports = __webpack_public_path__ + "static/img/logo7.75cdd55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo7.png
// module id = GY6N
// module chunks = 1